import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.versionStateIcon}}\n  <Hds::Badge @icon={{this.versionStateIcon}} @color={{this.versionStateColor}} @text={{t \"components.version-state.state\" state=@version.state}} />\n{{/if}}", {
  moduleName: "vagrant/components/version-state/index.hbs"
});